export default __webpack_public_path__ + "dfc3714e3a258a817c2ed099deff5521.png";